import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { Card, GreyCapsText } from 'components/core';
import _ProductImage from 'components/product-image';

export const productCardContainerStyles = css`
  padding: 19px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100%;

  @media (min-width: 600px) {
    max-width: 198px;
  }
`;

export const Container = styled(Card)`
  ${productCardContainerStyles}
`;

export const Content = styled.div`
  height: auto;
`;

export const ChipContainer = styled.div`
  padding-top: 5px;
  ${space}
`;

export const productCardImageStyles = css`
  margin-bottom: 12px;
  border-radius: 3px;
`;
export const ProductImage = styled(_ProductImage)`
  ${productCardImageStyles}
`;

export const Details = styled.div`
  width: 100%;
`;

export const Name = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-size: 14px;
  font-weight: bold;
  line-height: 17px;
  padding-bottom: 6px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const Brand = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-size: 12px;
  line-height: 14px;
  padding-bottom: 7px;
`;

export const StyledGreyCapsText = styled(GreyCapsText)`
  font-size: 11px;
  font-weight: bold;
  line-height: 150%;
  text-transform: none;
`;

export const FlowerGreyCapsText = styled(StyledGreyCapsText)`
  display: block;
  line-height: 125%;
  padding-bottom: 6px;

  &:first-child {
    padding-top: 1px;
    text-transform: capitalize !important;
  }

  &:last-child {
    padding-bottom: 0;
    text-transform: uppercase !important;
  }
`;

export const BadgesContainer = styled.div`
  display: flex;
  flex-flow: wrap;
  padding-top: 4px;
`;

export const PriceSection = styled.div`
  color: ${({ specialsColor, theme }) => (specialsColor ? theme.colors.red[60] : theme.colors.primaryBlue)};
  font-size: 14px;
  line-height: 15px;
  padding-bottom: 7px;
`;
